export default {
  theme: 'light',
  // 是否刷新列表
  isfreshMenu: false,
  // 系统按钮显示列表
  buttonList: []
}
